import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import GitHubCalendar from "react-github-calendar";
import { NavbarContext } from "../../context";
import { quickFacts, skillGroups } from "../../data/portfolioData";

export const About = () => {
  const { ref, inView } = useInView({ threshold: 0.25 });
  const { ref: calRef, inView: calInView } = useInView({ threshold: 0.1, triggerOnce: true });
  const setPage = useContext(NavbarContext);

  useEffect(() => {
    if (inView) setPage("about");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <section
      ref={ref}
      id="about-page"
      className="about-section"
      aria-labelledby="about-heading"
    >
      <div className="about-content-wrap">
        <div className="container-wide">
          <h2 id="about-heading" className="section-heading">
            About me.
          </h2>

          <div className="about-layout">
            <div className="about-prose-block">
              <p className="about-prose">
                <strong>I judge a project by what the business gets after launch.</strong>{" "}
                More customers who find you, fewer who give up, and fewer hours your staff
                spend copying data between tools. The framework matters much less than that.
              </p>
              <p className="about-prose">
                I started as a front-end developer at FPT Software and moved closer to the
                client every year. Today I run delivery for small businesses as a freelancer
                and at a U.S. web agency, and I still write much of the code myself.
              </p>
              <p className="about-prose">
                Sometimes the honest answer is that a business does not need new software at
                all. I will say that too.
              </p>

              <div className="about-skills-container">
                {skillGroups.map((group) => (
                  <div key={group.title} className="about-skills-group">
                    <h3 className="about-skills-title">{group.title}</h3>
                    <div className="about-skill-chips">
                      {group.items.map((skill) => (
                        <span key={skill} className="about-skill-chip">{skill}</span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="about-sidebar">
              <div className="about-fact-block">
                <h3 className="about-fact-title">Quick facts</h3>
                <ul className="about-fact-list">
                  {quickFacts.map((fact) => (
                    <li key={fact}>{fact}</li>
                  ))}
                </ul>
              </div>

              <div ref={calRef} className="github-card">
                <h3 className="github-card-title">GitHub activity</h3>
                <div className="github-calendar-wrap">
                  {calInView && (
                    <GitHubCalendar
                      username="punhe"
                      colorScheme="light"
                      theme={{
                        light: ["#ebebe6", "#fbe7a1", "#f8d664", "#e8b923", "#9c7a00"],
                        dark: ["#ebebe6", "#fbe7a1", "#f8d664", "#e8b923", "#9c7a00"],
                      }}
                      fontSize={11}
                      blockSize={10}
                      blockMargin={3}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
